import {useEffect,useState} from 'react';
import { rootApi } from '../api/rootApi';

const useTours = ()=>{
    const [tours, setTours] = useState([]);
    const [loading, setLoading] =useState(true);


    useEffect(() => {
        fetch(rootApi.tours)
       .then(res => res.json())
       .then(result => {
         setTours(result.tours)
         setLoading(false);
       });
     }, [tours,loading]);


return [ tours, loading ];

}

export default useTours;